/**
 * LIBRERÍA DE GESTIÓN DE LOCALSTORAGE CON EXPIRACIÓN
 * */
export default {
  /**
   * Guarda en la local storage un elemento y le fija cierta expiración en
   * milisegundos por ttl
   * @param {any} key      Key dentro del localstorage en el que guardar este elemento.
   * @param {any} value    Valor a guardar en la local storage
   * @param {any} ttl      ms que se mantiene vivo el elemento
   */
  setWithExpiry: function (key, value, ttl) {
    const now = new Date();

    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
  },

  /**
   * Devuelve un valor del local storage si este sigue en siendo válido.
   * milisegundos por ttl
   * @param {any} key      Key dentro del localstorage en el que buscar este elemento.
   */
  getWithExpiry: function (key) {
    const itemStr = localStorage.getItem(key);

    /* Si no existe se devuelve null */
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();

    /* Se verifica si es elemento válido por expiración */
    if (now.getTime() > item.expiry) {
      /* No es válido, se limpia el Local Storage y se devuelve null */
      localStorage.removeItem(key);
      return null;
    }
    /* Elemento válido y además dentro del periodo de expiración. */
    return item.value;
  },
};
